/**
 * Adjetivos: the word, type what it means.
 *
 * The same shared card every translation deck uses. What is specific to this
 * deck is on the back, where the agreement forms are.
 */
import { TypeTranslationCardFront } from '@/components/practice/TypeTranslationCard';

import type { CardFrontProps } from '../types';

import type { AdjetivoPayload } from './types';

export function CardFront({ card, onAnswer }: CardFrontProps<AdjetivoPayload>) {
  return (
    <TypeTranslationCardFront
      card={card}
      onAnswer={onAnswer}
      headword={card.de}
      subtitle={card.payload.pos === 'adverb' ? 'advérbio' : undefined}
    />
  );
}
